export default function Logo({ size = 36 }) {
  return (
    <img
      src="/logo.png"
      width={size}
      height={size}
      data-testid="brand-logo"
      alt="Bowegans Car Care logo"
      className="block shrink-0 rounded-full"
    />
  );
}
